// extracted by mini-css-extract-plugin
module.exports = {"container":"Printable_container__2YK31"};